import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HomeButtonComponent } from './home-button.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    RouterModule
  ],
  declarations: [HomeButtonComponent],
  exports: [HomeButtonComponent]
})
export class HomeButtonModule {}
